<template>
  <div class="settlement-container">
    <div class="fixed-wrapper">
      <div class="settlement-header">
        查询结算记录
      </div>
      <div class="search-row">
        <div class="settlement-material">
          <span>物料名称/编码</span>
          <el-input
            placeholder="请输入物料名称或物料编码"
            v-model="material"
            clearable
            size="mini"
          ></el-input>
        </div>
        <el-button
          type="primary"
          size="mini"
          :loading="isLoading"
          @click="handleSearch"
          >查询</el-button
        >
      </div>
      <div class="status-row">
        <div
          :class="{ 'is-active': activeStatus === status.value }"
          v-for="(status, index) in statusArr"
          :key="index"
          @click="handleToggleStatus(status.value)"
        >
          {{ status.label }}
        </div>
      </div>
    </div>
    <div class="settlement-content">
      <el-table
        :data="settlementList"
        size="mini"
        style="width: 100%"
        height="100%"
        v-loading="isLoading"
      >
        <el-table-column prop="itemName" label="物料名称" width="200">
        </el-table-column>
        <el-table-column prop="itemCode" label="物料编码" width="150">
        </el-table-column>
        <el-table-column label="品项" width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.itemQualityName | qualityType" size="mini">
              {{ scope.row.itemQualityName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="100">
        </el-table-column>
        <el-table-column prop="unit" label="单位" width="100">
        </el-table-column>
        <el-table-column prop="price" label="价格" width="100">
        </el-table-column>
        <el-table-column prop="currency" label="币种" width="100">
        </el-table-column>
        <el-table-column prop="appliedAmount" label="已结清金额" width="100">
        </el-table-column>
        <el-table-column prop="surplusAmount" label="剩余金额" width="100">
        </el-table-column>
        <el-table-column prop="createOn" label="购买日期" width="200">
          <template slot-scope="scope">
            {{ scope.row.createOn | date }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      supplier: '',
      material: '',
      statusArr: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待收款',
          value: false
        },
        {
          label: '已收款',
          value: true
        }
      ],
      activeStatus: '',
      settlementList: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/indent')
    this.$store.commit('setSubActiveIndex', '/indent/settlement')
    this.$store.commit('setAsideWidth', 300)
  },
  created() {
    this.getSettlementList()
  },
  methods: {
    getSettlementList() {
      this.isLoading = true
      const params = {
        material: this.material,
        state: this.activeStatus,
        skipCount: (this.currentPage - 1) * this.pageSize,
        maxResultCount: this.pageSize
      }
      this.$http
        .get('/api/services/inquiryApp/entrust/GetAllEntrustPay', params)
        .then(res => {
          this.total = res.result.totalCount
          this.settlementList = res.result.items
          this.isLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message.error('获取数据失败！')
          this.isLoading = false
        })
    },
    handleSearch() {
      this.currentPage = 1
      this.getSettlementList()
    },
    handleToggleStatus(value) {
      this.activeStatus = value
      this.getSettlementList()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.getSettlementList()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.getSettlementList()
    }
  }
}
</script>
<style lang="less" scoped>
.settlement-container {
  height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.settlement-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.fixed-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.settlement-material {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 30px;
  span {
    margin-right: 15px;
    color: #2f343c;
  }
}

.settlement-material {
  width: 25%;
}

.status-row {
  height: 35px;
  display: flex;
  position: relative;
  margin: 15px 0;
  .is-active {
    border: 1px solid #027cff;
    color: #027cff;
    z-index: 5;
  }
  > div {
    height: 35px;
    padding: 0 10px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #b7bbc8;
    position: absolute;
    color: #2f343c;
    user-select: none;
    &:hover {
      border: 1px solid #027cff;
      color: #027cff;
      z-index: 5;
      cursor: pointer;
    }
    &:first-child {
      border-radius: 3px 0 0 3px;
      left: 0;
    }
    &:nth-child(2) {
      border-radius: 0;
      left: 49px;
    }
    &:last-child {
      left: 112px;
      border-radius: 0 3px 3px 0;
    }
  }
}
.settlement-content {
  height: calc(100% - 210px);
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
